import { GetCustomerPartNumbersApiParameter } from "@auer-steel/Services/CustomerPartNumberService";
import { AuerState } from "@auer-steel/Store/AuerState";
import {
    CustomerPartNumbersDataViewContext,
    getCustomerPartNumbersDataView,
} from "@auer-steel/Store/Data/CustomerPartNumbers/CustomerPartNumbersSelector";
import loadCustomerPartNumbers from "@auer-steel/Store/Data/CustomerPartNumbers/Handlers/LoadCustomerPartNumbers";
import updateSearchFields from "@auer-steel/Store/Pages/MyPartNumbers/Handlers/UpdateSearchFields";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import qs from "qs";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: AuerState) => {
    return {
        session: state.context.session,
        customerPartNumbersDataView: getCustomerPartNumbersDataView(
            state,
            state.myPartNumbers.getCustomerPartNumbersParameter,
        ),
        getCustomerPartNumbersParameter: state.myPartNumbers.getCustomerPartNumbersParameter,
        location: getLocation(state),
    };
};

const mapDispatchToProps = {
    loadCustomerPartNumbers,
    updateSearchFields,
    signOut,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const MyPartNumbersPage: React.FC<Props> = ({
    loadCustomerPartNumbers,
    updateSearchFields,
    signOut,
    session,
    customerPartNumbersDataView,
    id,
    history,
    location,
    getCustomerPartNumbersParameter,
}) => {
    let firstLoad = false;
    React.useEffect(() => {
        firstLoad = true;
        const pageSizeCookie = getCookie("MyPartNumbers-PageSize");
        const pageSize = pageSizeCookie ? parseInt(pageSizeCookie, 10) : undefined;
        if (session?.isAuthenticated && location.search) {
            const getCustomerPartNumbersApiParameter = parseQueryString<GetCustomerPartNumbersApiParameter>(
                location.search,
            );
            if (pageSize) {
                getCustomerPartNumbersApiParameter.pageSize = pageSize;
            }
            updateSearchFields({ ...getCustomerPartNumbersApiParameter, type: "Replace" });
        }
    }, []);

    useEffect(() => {
        if (!session?.isAuthenticated){
            signOut();
        }
    });
    useEffect(() => {
        if (!firstLoad) {
            const queryString = qs.stringify(getCustomerPartNumbersParameter);
            history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }
    }, [getCustomerPartNumbersParameter]);

    React.useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (session?.isAuthenticated && !customerPartNumbersDataView.value && !customerPartNumbersDataView.isLoading) {
            loadCustomerPartNumbers(getCustomerPartNumbersParameter);
        }
    });

    return (
        <Page>
            <CustomerPartNumbersDataViewContext.Provider value={customerPartNumbersDataView}>
                <Zone contentId={id} zoneName="Content" />
            </CustomerPartNumbersDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(MyPartNumbersPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

export const MyPartNumbersPageContext = "MyPartNumbersPage";
